import { KpiCard } from './KpiCard';
import { fmtBRL, fmtPct } from './formatadores';
import type { DashboardFinanceiro, StatusReceita } from '../../types';

interface Props {
  d: DashboardFinanceiro;
  onVerStatus?: (s: StatusReceita) => void;
  onVerVencidos?: () => void;
  /** Cota do sócio logado (soma da divisão), se ele estiver vinculado. */
  minhaCota?: { nome: string; valor: number } | null;
}

export function KpiGrid({ d, onVerStatus, onVerVencidos, minhaCota }: Props) {
  const k = d.kpis;
  const vencido = d.aging.vencido;
  const pctReceb = k.total_receita > 0 ? k.total_recebido / k.total_receita : 0;
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
      <KpiCard rotulo="Receita total" valor={fmtBRL(k.total_receita)} tom="azul"
        sub={`${k.qtd_processos} processo${k.qtd_processos === 1 ? '' : 's'}`} />
      <KpiCard rotulo="Recebido" valor={fmtBRL(k.total_recebido)} tom="verde" progresso={pctReceb}
        sub={`${fmtPct(pctReceb * 100)} do total`}
        onClick={onVerStatus ? () => onVerStatus('recebido') : undefined} />
      <KpiCard rotulo="A receber" valor={fmtBRL(k.total_a_receber)} tom="ambar"
        sub={`${k.qtd_previsto + k.qtd_parcial} em aberto`}
        onClick={onVerStatus ? () => onVerStatus('previsto') : undefined} />
      <KpiCard rotulo="Vencido" valor={fmtBRL(vencido)} tom={vencido > 0 ? 'vermelho' : 'neutro'}
        sub="passou da data prevista"
        onClick={vencido > 0 ? onVerVencidos : undefined} />
      <KpiCard rotulo="Ticket médio" valor={fmtBRL(k.ticket_medio)} tom="neutro" sub="por processo" />
      {minhaCota
        ? <KpiCard rotulo="Minha cota" valor={fmtBRL(minhaCota.valor)} tom="azul" sub={minhaCota.nome} />
        : <KpiCard rotulo="Sucumbência" valor={fmtBRL(k.total_sucumbencia)} tom="neutro" sub="total deferido" />}
    </div>
  );
}
